export const additionalNotifyMethodKeys = {
    name: 'name',
    description: 'description',
    notifyMethodType: 'notifyMethodType',
    phoneNumber: 'phone',
    phoneExtension: 'phoneExtension',
    email: 'email',
    day: 'days',
    time: 'time',
    startTime: 'startTime',
    endTime: 'endTime',
    phoneInput: 'phoneInput',
    emailInput: 'emailInput',
    active: 'active',
}

export const timeOptionKeys = {
    allDay: 'allDay',
    customTime: 'customTime',
}

export const notifyTimeOption = [
    {label: 'All day', value: timeOptionKeys.allDay},
    {label: 'Custom time', value: timeOptionKeys.customTime},
]

export const weekDayKeys = {
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
    sunday: 'sunday',
}

export const weekDayOption = [
    {label: 'Monday', value: weekDayKeys.monday},
    {label: 'Tuesday', value: weekDayKeys.tuesday},
    {label: 'Wednesday', value: weekDayKeys.wednesday},
    {label: 'Thursday', value: weekDayKeys.thursday},
    {label: 'Friday', value: weekDayKeys.friday},
    {label: 'Saturday', value: weekDayKeys.saturday},
    {label: 'Sunday', value: weekDayKeys.sunday},
]
